module.exports = __webpack_public_path__ + "static/bolagsordning-2023-971cad09a88150c7d2ec10c3fff61e13.pdf";